module.exports = __webpack_public_path__ + "img/sort-none.39c0a067.svg";